export enum ToolsStatusTypes {
  GET_TOOLS_STATUS_REQUEST = '@tools/GET_TOOLS_STATUS_REQUEST',
  GET_TOOLS_STATUS_SUCCESS = '@tools/GET_TOOLS_STATUS_SUCCESS',
  GET_TOOLS_STATUS_FAILURE = '@tools/GET_TOOLS_STATUS_FAILURE',
  CREATE_INCIDENT_REQUEST = '@tools/CREATE_INCIDENT_REQUEST',
  CREATE_INCIDENT_SUCCESS = '@tools/CREATE_INCIDENT_SUCCESS',
  CREATE_INCIDENT_FAILURE = '@tools/CREATE_INCIDENT_FAILURE',
  DELETE_INCIDENT_REQUEST = '@tools/DELETE_INCIDENT_REQUEST',
  DELETE_INCIDENT_SUCCESS = '@tools/DELETE_INCIDENT_SUCCESS',
  DELETE_INCIDENT_FAILURE = '@tools/DELETE_INCIDENT_FAILURE',
}

export interface ToolsTypes {
  cache_name: string;
  tool_name: string;
  principal_tool: boolean;
  status: string;
  description: string;
  time: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface ToolsStatusState {
  tools_status: Array<ToolsTypes>;
  readonly request: RequestState;
}
